import { createContext } from 'react';

import { ListaPerguntas, Pergunta } from 'api/DuvidasFrequentes';
import {
  IAssembleiaAssociadoEvento,
  IAssembleiaContaAssociado,
} from 'store/modules/AssembleiasAssociadoReducer';
import { IAuthUserReducer } from 'store/modules/AuthReducer';

interface AssembleiaAssociadoContext {
  usuario?: IAuthUserReducer;
  currentEvent: IAssembleiaAssociadoEvento | null;
  loadingEvent: boolean;
  loadingPautas: boolean;
  hasPermissionVideos: boolean;
  hasPermissionDocumentos: boolean;
  hasPermissionParticipar: (contas: IAssembleiaContaAssociado[]) => boolean;
  hasPermissionDuvidas: boolean;
  hasPermissionVerPautas: boolean;
  abrirModalContas: () => void;
  abrirModalContasConfirmadas: () => void;
  abrirModalMenorEmancipado: () => void;
  abrirDocumentos: () => void;
  abrirVideos: () => void;
  isColaborador: boolean;
  isConvocado: (contas: IAssembleiaContaAssociado[]) => boolean;
  perguntas: ListaPerguntas | null;
  atualizarPergunta: (changes: Pergunta) => void;
  isPerguntaAdmin: (pergunta: Pergunta) => boolean;
  isPerguntaUsuario: (pergunta: Pergunta) => boolean;
  isPerguntaNaoLida: (pergunta: Pergunta) => boolean;
}

export default createContext<AssembleiaAssociadoContext>({
  currentEvent: null,
  loadingEvent: false,
  loadingPautas: false,
  hasPermissionVideos: false,
  hasPermissionDocumentos: false,
  hasPermissionParticipar: () => false,
  hasPermissionDuvidas: false,
  hasPermissionVerPautas: false,
  abrirModalContas: () => {},
  abrirModalContasConfirmadas: () => {},
  abrirModalMenorEmancipado: () => {},
  abrirDocumentos: () => {},
  abrirVideos: () => {},
  isColaborador: false,
  isConvocado: () => false,
  perguntas: null,
  atualizarPergunta: () => {},
  isPerguntaAdmin: () => false,
  isPerguntaUsuario: () => false,
  isPerguntaNaoLida: () => false,
});
